import React from "react";
import "../styles/Section.css";

const features = [
  {
    icon: "⚡",
    title: "High Performance",
    description:
      "Optimized architecture ensuring lightning-fast performance and seamless scalability."
  },
  {
    icon: "🔒",
    title: "Enterprise Security",
    description:
      "Secure development practices aligned with industry standards and compliance."
  },
  {
    icon: "🌍",
    title: "Cloud Scalability",
    description:
      "Cloud-native solutions designed to grow with your business."
  }
];

const About = () => {
  return (
    <section id="about" className="section">
      <h2>Why Choose SoftCo</h2>
      <div className="cards">
        {features.map((feature, index) => (
          <div key={index} className="card animate">
            <h3>{feature.icon} {feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default About;